// extracted by mini-css-extract-plugin
export default {"inactive":"SideMenu_inactive__tmN5V"};